$(document).on("turbolinks:load", () => {
   let handleNotesFieldVisibility = function() {
    if($("#unreleased_appearance_note_category").children("option:selected").val() === 'other') { 
    $("#unreleased_appearance_notes").show(); 
  } else {
    $("#unreleased_appearance_notes").hide();
  }
};

 $(document).on("change", "#unreleased_appearance_note_category", handleNotesFieldVisibility); 

  window.handleNotesFieldVisibility = handleNotesFieldVisibility;

});
